/**
 * Los contadores por estado que van encima de la tabla del banco de jurados,
 * que tambien filtran al hacerles clic.
 *
 * Aqui el estado vive en "status" y tiene nombres propios: "Aceptó" es lo que
 * en pantalla se llama "En estudio", y "Sin verificar" es "Inscritos sin
 * revisar".
 *
 * El chip de Total muestra las filas de la pestana que se esta viendo. Antes
 * ese numero salia de un contador del hook que nadie actualizaba, asi que en
 * la pestana de Postulaciones siempre decia cero.
 */
import { ChipEstado, NEUTRO, contarPorChip, filtrarPorChip } from "./chipsEstado";

export type { ChipEstado } from "./chipsEstado";
export { colorDeFondo } from "./chipsEstado";

/** El chip que no filtra nada. */
export const CLAVE_TODAS = "total";

/** En los jurados el estado vive en este campo. */
const CAMPO = "status";

export const CHIPS_ESTADO_JURADO: ChipEstado[] = [
  {
    clave: "rechazado",
    etiqueta: "Rechazado",
    estados: ["Rechazado"],
    clase: "font-color-DB2828",
    claseNumero: "font-color-DB2828",
    color: "#DB2828",
  },
  {
    clave: "subsanado",
    etiqueta: "Subsanado",
    estados: ["Subsanado"],
    clase: "font-color-6435C9",
    claseNumero: "font-color-6435C9",
    color: "#6435C9",
  },
  {
    clave: "subsanar",
    etiqueta: "Subsanar",
    estados: ["Subsanar"],
    clase: "font-color-F28C02",
    claseNumero: "font-color-F28C02",
    color: "#F28C02",
  },
  {
    clave: "enEstudio",
    etiqueta: "En estudio",
    estados: ["Aceptó"],
    clase: "font-color-00904C",
    claseNumero: "font-color-00904C",
    color: "#00904C",
  },
  {
    clave: "inscritos",
    etiqueta: "Inscritos sin revisar",
    estados: ["Sin verificar"],
    clase: "",
    claseNumero: "font-color-black",
    color: NEUTRO,
  },
  {
    clave: CLAVE_TODAS,
    etiqueta: "Total",
    estados: null,
    clase: "",
    claseNumero: "font-color-F28C02",
    color: "#F28C02",
  },
];

/** Los jurados que le corresponden a un chip. */
export const juradosDelChip = (jurados: any[], clave?: string | null): any[] =>
  filtrarPorChip(jurados, CHIPS_ESTADO_JURADO, clave, CAMPO);

/** Cuantos jurados le corresponden a un chip. */
export const contarChipJurado = (
  jurados: any[],
  clave?: string | null
): number => contarPorChip(jurados, CHIPS_ESTADO_JURADO, clave, CAMPO);
